import feathersClient, { makeServicePlugin, BaseModel } from '@/plugins/feathers-client';

class BHUserEngagementMetrics extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  static modelName = 'BHUserEngagementMetrics'
  static instanceDefaults() {
    return {
      user_id: null,
      engagement_score: 0,
      avg_completion_time_hours: 0,
      total_campaigns_completed: 0,
      total_campaigns_allocated: 0,
      fast_completion_count: 0,
      avg_rating_given: 0,
      last_campaign_completed_at: null
    }
  }
}

const servicePath = 'bh-user-engagement-metrics';
const servicePlugin = makeServicePlugin({
  Model: BHUserEngagementMetrics,
  service: feathersClient.service(servicePath),
  servicePath
});

feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
});

export default servicePlugin;
